import React from 'react'
import type { PRect } from '@reach/rect'


export type Refs = {
  button: HTMLButtonElement
  list: HTMLDivElement
  items: HTMLElement[]
}

export type State = {
  buttonId: string
  buttonRect: any
  selectionIndex: number
  isOpen: boolean
  isKeyDown: boolean
  closingWithClick: boolean
}

export type MenuContextValue = {
  refs: {
    current: Refs
  }
  state: State
  setState: (state: Partial<State>) => void
  handleMenuBlur: (event: React.FocusEvent) => void
  handleMenuClick: (event: React.MouseEvent) => void
  handleMenuKeyDown: (event: React.MouseEvent) => void
  handleMenuMouseDown: (event: React.MouseEvent) => void
  handleMenuMouseEnter: (event: React.MouseEvent) => void
  handleMenuMouseLeave: (event: React.MouseEvent) => void
  handleListBlur: (event: React.FocusEvent) => void
  handleListKeyDown: (event: React.KeyboardEvent) => void
  handleListMouseEnter: (event: React.MouseEvent) => void
  handleListMouseLeave: (event: React.MouseEvent) => void
  getListStyles: (rect: PRect) => { [key: string]: any }
}

const MenuContext = React.createContext<MenuContextValue>(null)


export default MenuContext
